import React from 'react';
import { connect } from 'react-redux';
import NavigationActions from '../../redux/navigationRedux';
import getCategoryNavigationStepMapping from '../../services/helper/categoryNavigationStepMapping';
import style from './dependencyItem.scss';
import ConfigurationActions from '../../redux/configurationRedux';

function DependencyItemView({
    navigate,
    part,
    closeModal,
    addMarkedDependency,
}) {
    const navigateToCategoryStep = (event, clickedPart) => {
        const navigationTargetStep = getCategoryNavigationStepMapping(
            clickedPart.category
        );
        closeModal(event);
        navigate(navigationTargetStep.id);
        // Add the clicked part to the list of markedDependencies in state
        addMarkedDependency(clickedPart.uid);
    };

    return (
        <li
            className={style.partLink}
            onClick={event => navigateToCategoryStep(event, part)}
        >
           {part.code !== '' ? `${part.name} [${part.code}]` : `${part.name}`}
        </li>
    );
}
const mapStateToProps = state => ({
    navigation: state.navigation,
});
const mapDispatchToProps = dispatch => ({
    navigate: step => dispatch(NavigationActions.navigate(step)),
    addMarkedDependency: partUid =>
        dispatch(ConfigurationActions.addMarkedDependency(partUid)),
});

const DependencyItem = connect(
    mapStateToProps,
    mapDispatchToProps
)(DependencyItemView);

export default DependencyItem;
